import { render, staticRenderFns } from "./communityactivityapplication.vue?vue&type=template&id=3858fea5&"
import script from "./communityactivityapplication.vue?vue&type=script&lang=js&"
export * from "./communityactivityapplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports